import { getTemplateNavHeaderPrimaryStyles } from './NavHeaderPrimary.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="ts-container-fluid">
  <slot name="primaryLinks"></slot>
  <div class="nav-divider">
    <slot name="primaryDivider"></slot>
  </div>
  
  <!-- Menu Dropdown -->
  <slot name="primaryMenu"></slot>
  <div class="mobile-header">
    <slot name="mobileMenuNavigation"></slot> 
  </div>
</div>
`

class NavHeaderPrimary extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderPrimaryStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderPrimary connectedCallback', this)
  }
}

if (!customElements.get('ts-navheader-primary')) {
  customElements.define('ts-navheader-primary', NavHeaderPrimary)
}
export { NavHeaderPrimary }
